(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 1548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1503);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7623);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);





var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/404.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "404 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: ["The page you are looking for does not exist. ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}), " Sorry :("]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      href: "/",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Head home"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);
/*
  import Link from "next/link";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]">
    <div className="flex h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
      <img
        src="/illustrations/404-Error-illustration.svg"
        alt="404 image"
        height="250px"
        width="250px"
        className="object-cover"
      />

      <p className="mt-8 max-w-sm text-center text-xl">
        Oops! We couldn't find that page. <br />
        Let's get you back on track.
      </p>

      <Link href="/" prefetch={true}>
        <a className="mt-8 rounded-lg bg-primary px-6 py-4 text-xl">Head home</a>
      </Link>

      <footer className="fixed bottom-10 left-1/2 -translate-x-1/2 transform text-center">
        <small className="opacity-70">
          Illustrations by{" "}
          <a href="https://storyset.com/web" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </small>
      </footer>
    </div>
  </div>
);

export default NotFound;

*/

/***/ }),

/***/ 9525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2057);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5271);
/* harmony import */ var _components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9523);
/* harmony import */ var _components_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4834);
/* harmony import */ var _contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3104);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1008);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7623);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7991);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_utils_analytics__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7981);
/* harmony import */ var _utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _404__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1548);
/* harmony import */ var _500__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3531);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2676);













function Home() {
  var _store$id;

  var context = (0,_contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_4__/* .useStoreContext */ .Q)();
  var store = context === null || context === void 0 ? void 0 : context.storeData;
  var theme = context === null || context === void 0 ? void 0 : context.themeData;
  var error = context === null || context === void 0 ? void 0 : context.error;
  var storeUrl = context === null || context === void 0 ? void 0 : context.storeUrl;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (store !== null) {
      setLoading(false);
    }
  }, [store]); // Top of the buyer funnel. Keyed on the store id so a re-render does not
  // re-emit, and guarded on the store having actually resolved — firing while
  // `store` is still null would count a load that never showed anything.

  var storeId = (_store$id = store === null || store === void 0 ? void 0 : store.id) !== null && _store$id !== void 0 ? _store$id : store === null || store === void 0 ? void 0 : store._id;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!storeId) return;
    (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(_utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__.EVENTS.STORE_VIEWED, {
      store_has_home_page: Boolean(store === null || store === void 0 ? void 0 : store.homePageEnabled),
      store_product_count: Array.isArray(store === null || store === void 0 ? void 0 : store.products) ? store.products.length : undefined
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId]);
  if (error && error.code === 500) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_500__WEBPACK_IMPORTED_MODULE_9__["default"], {});
  if (error && error === 404) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_404__WEBPACK_IMPORTED_MODULE_8__["default"], {});
  if (!store || loading) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}); // below is the old code for the using pageProps when we were using getServerSideProps
  // const { storeData: store, storeUrl, error, themeData: theme } = props;
  // if (error && error.code === 500) return <Error500Page />;
  // if (error && error === 404) return <NotFound />;
  // if (!store) return <LoaderComponent />;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("title", {
        children: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), store !== null && store !== void 0 && store.facebookDomainVerificationId ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "facebook-domain-verification",
        content: store === null || store === void 0 ? void 0 : store.facebookDomainVerificationId
      }) : "", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("link", {
        rel: "icon",
        href: "https://dm2buy.blob.core.windows.net/dm2buy/favicon.ico"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("link", {
        href: "https://fonts.googleapis.com/css2?family=Roboto:wght@700;900&family=Roboto:wght@400;700&display=swap",
        rel: "stylesheet"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:image",
        content: store !== null && store !== void 0 && store.logo ? (0,_lib_media__WEBPACK_IMPORTED_MODULE_5__/* .ogImage */ .Qf)(store.logo, store.logoV2) : "https://dm2buy.blob.core.windows.net/dm2buy/favicon.ico"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:site_name",
        content: "dm2buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "og:url",
        content:  true ? window.location.href : 0
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:card",
        content: "summary"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:url",
        content:  true ? window.location.href : 0
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        name: "twitter:title",
        content: (store === null || store === void 0 ? void 0 : store.storeName) || "DM2Buy Store"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "twitter:description",
        content: (store === null || store === void 0 ? void 0 : store.storeBio) || "Online store powered by DM2Buy"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("meta", {
        property: "twitter:image",
        content: "https:" + (store === null || store === void 0 ? void 0 : store.logo) || 0
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__/* .MainHome */ .q, {
      store: store,
      theme: theme
    })]
  });
}

/***/ }),

/***/ 7463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9525);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9248,885,3129,5695,760,2455,7234,6166,4162,9117,2868,4469,1030,2737,3352,9150,5713,6765,9523,9774,2888,179], function() { return __webpack_exec__(7463); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);